<template>
  <div v-if="showBanner" class="cookie-consent-banner">
    <div class="cookie-content">
      <div class="cookie-text">
        <h4>🍪 Cookie Notice</h4>
        <p>
          We use cookies and similar technologies to enhance your browsing experience, serve personalized ads or content, 
          and analyze our traffic. We also share information about your use of our site with our advertising partners.
          By clicking "Accept All", you consent to our use of cookies.
        </p>
      </div>
      <div class="cookie-buttons">
        <button @click="acceptAll" class="btn-accept">Accept All</button>
        <button @click="acceptNecessary" class="btn-necessary">Necessary Only</button>
        <router-link to="/privacy-policy" class="btn-privacy">Privacy Policy</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookieConsent',
  data() {
    return {
      showBanner: false
    }
  },
  mounted() {
    this.checkCookieConsent()
  },
  methods: {
    checkCookieConsent() {
      const consent = localStorage.getItem('cookie-consent')
      if (!consent) {
        this.showBanner = true
      }
    },
    acceptAll() {
      localStorage.setItem('cookie-consent', 'all')
      this.showBanner = false
      // Enable all tracking and ads
      this.enableGoogleAds()
      this.enableAnalytics()
    },
    acceptNecessary() {
      localStorage.setItem('cookie-consent', 'necessary')
      this.showBanner = false
      // Only enable necessary cookies
      this.enableAnalytics(false) // Disable personalized analytics
    },
    enableGoogleAds() {
      // Enable Google AdSense
      if (window.adsbygoogle && window.adsbygoogle.loaded !== true) {
        try {
          (window.adsbygoogle = window.adsbygoogle || []).push({})
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log('AdSense error:', e)
        }
      }
    },
    enableAnalytics(personalized = true) {
      // Configure Google Analytics based on consent
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'ad_storage': personalized ? 'granted' : 'denied',
          'analytics_storage': personalized ? 'granted' : 'denied',
          'personalization_storage': personalized ? 'granted' : 'denied',
          'functionality_storage': 'granted',
          'security_storage': 'granted'
        })
      }
    }
  }
}
</script>

<style scoped>
.cookie-consent-banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.95);
  color: white;
  padding: 20px;
  z-index: 10000;
  box-shadow: 0 -4px 12px rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(10px);
}

.cookie-content {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
}

.cookie-text {
  flex: 1;
}

.cookie-text h4 {
  margin: 0 0 10px 0;
  font-size: 1.2rem;
  color: #4CAF50;
}

.cookie-text p {
  margin: 0;
  line-height: 1.5;
  font-size: 0.95rem;
  opacity: 0.9;
}

.cookie-buttons {
  display: flex;
  gap: 15px;
  flex-shrink: 0;
}

.btn-accept,
.btn-necessary,
.btn-privacy {
  padding: 12px 24px;
  border: none;
  border-radius: 25px;
  cursor: pointer;
  font-weight: 600;
  text-decoration: none;
  display: inline-block;
  text-align: center;
  transition: all 0.3s ease;
  font-size: 0.9rem;
}

.btn-accept {
  background: #4CAF50;
  color: white;
}

.btn-accept:hover {
  background: #45a049;
  transform: translateY(-2px);
}

.btn-necessary {
  background: transparent;
  color: white;
  border: 2px solid rgba(255, 255, 255, 0.5);
}

.btn-necessary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: white;
}

.btn-privacy {
  background: transparent;
  color: #4CAF50;
  border: 2px solid #4CAF50;
}

.btn-privacy:hover {
  background: #4CAF50;
  color: white;
  text-decoration: none;
}

@media (max-width: 768px) {
  .cookie-content {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  .cookie-buttons {
    flex-wrap: wrap;
    justify-content: center;
  }
  
  .btn-accept,
  .btn-necessary,
  .btn-privacy {
    min-width: 120px;
  }
}
</style>
